{
  "name": "@uppy/google-drive-picker",
  "description": "The Google Drive Picker plugin for Uppy lets users import files from their Google Drive account",
  "version": "0.4.2",
  "license": "MIT",
  "main": "lib/index.js",
  "type": "module",
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "typecheck": "tsc --build"
  },
  "keywords": [
    "file uploader",
    "google drive",
    "google picker",
    "cloud storage",
    "uppy",
    "uppy-plugin"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "dependencies": {
    "@uppy/companion-client": "workspace:^",
    "@uppy/provider-views": "workspace:^",
    "@uppy/utils": "workspace:^",
    "preact": "^10.5.13"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  },
  "devDependencies": {
    "@uppy/core": "workspace:^",
    "typescript": "^5.8.3"
  }
}
